import { render, staticRenderFns } from "./ModalResidentialStatusEdit.vue?vue&type=template&id=7d56a4f8&"
import script from "./ModalResidentialStatusEdit.vue?vue&type=script&lang=js&"
export * from "./ModalResidentialStatusEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports